/**
 * MODULE: _shared/frontend/lib/frontend/utils/brainActivityEvents.ts
 * PURPOSE: Same-tab bus when engagement signals arrive (Postmark poll, email sent, page_engaged).
 * PUBLIC_API: BRAZN_BRAIN_ACTIVITY_CHANGED, notifyBrainActivityChanged
 * SIDE_EFFECTS: window CustomEvent dispatch
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 38 / 100 lines
 * RECENT: 2026-05-26 [2.2.1257] — fanout source for SSE push invalidation.
 * RECENT_PRIOR: 2026-05-26 [2.2.1253] — sequence_sent + sms_sent sources for messaging outreach parity.
 */

export const BRAZN_BRAIN_ACTIVITY_CHANGED = 'brazn-brain-activity-changed';

export type BrainActivityChangedDetail = {
  source?: 'postmark' | 'email_sent' | 'sequence_sent' | 'sms_sent' | 'page_engaged' | 'poll' | 'manual' | 'fanout' | 'quota_sync';
  entity_type?: string;
  entity_id?: string;
  /** dashboard = Home strip only; crm = entity drawers; all (default) = assistant + dashboard + CRM */
  scope?: 'all' | 'dashboard' | 'crm';
};

/** Notify brain surfaces to drop stale engagement insights after activity_events fan-out. */
export function notifyBrainActivityChanged(
  detail: BrainActivityChangedDetail = { scope: 'all' },
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BRAZN_BRAIN_ACTIVITY_CHANGED, { detail }));
}
